import { z } from "zod";

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url().default("http://localhost:8000"),
  VITE_GOOGLE_CLIENT_ID: z.string().default(""),
  VITE_APP_NAME: z.string().default("Circuit Forge"),
  // Billing UX has a real backend for plan + wallet reads now (see
  // backend/billing/router.py). Top-up checkout / auto-recharge /
  // invoices remain server-side stubs until Stripe lands. Set to "1"
  // only when working on the UI offline (no backend reachable).
  VITE_BILLING_MOCK: z.union([z.literal("0"), z.literal("1")]).default("0"),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error("Invalid environment variables:", parsed.error.format());
  throw new Error("Invalid environment variables — check your .env file.");
}

export const env = parsed.data;
